// eslint-disable-next-line prettier/prettier
import { ticketSellerAdminRouteNames } from '../routeNames/ticketSellerAdminRouteNames'

import { getPropsFromParams } from '../utils.routing'
import ReportsPage from './../../components/ticket-seller-admin/reports-page.vue'
import ReportPage from './../../components/ticket-seller-admin/report-page.vue'

export const TicketSellerAdminRoutes = [
  {
    path: '/ticket-seller-admin/reports',
    props: getPropsFromParams,
    name: ticketSellerAdminRouteNames.reportsAdmin,
    component: ReportsPage,
    meta: {
      requiresAuthentication: true,
      redirectIfAuthenticated: false,
      title: 'Reports',
    },
  },
  {
    path: '/ticket-seller-admin/report',
    props: getPropsFromParams,
    name: ticketSellerAdminRouteNames.reportAdmin,
    component: ReportPage,
    meta: {
      requiresAuthentication: true,
      redirectIfAuthenticated: false,
      title: 'Report',
    },
  },
]
